import React from 'react';
import Modal from 'react-bootstrap-modal';
import Dropzone from 'react-dropzone';
import './fileSelectionModal.css';
import { apiGet } from '../services/apiClient';
import { getCurrentUserCompanyId } from '../services/userRights';
import SelectInput from '../controls/selectInput.jsx';

export default class FileSelectionWithCarrierSelectionModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            file: null,
            carrierId: null,
            carriersList: [],
			dragOver: false,
            promiseResolve: null,
            promiseReject: null            
        };

        apiGet('parcels/cost/carriers/')
            .then(data => {
                this.setState({ carriersList: data.entries.map(item => { return { value: item.id, label: item.name } }) });
            });
    }

    open(title) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
				file: null,
				dragOver: false,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }
	
	onDrop(files) {
		if(files && files.length > 0) {
			this.setState({
				file: files[0]
			});
		}
	}

    close(result) {
        if (result) {
            this.state.promiseResolve({file: this.state.file, carrierId: this.state.carrierId});
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            title: "",
			file: null,
			dragOver: false,
            promiseResolve: null,
            promiseReject: null
        });
    }

	renderDropzoneBody() {
		if (this.state.file == null) {
			return (
				<div className="dropzone-label">
					<span>Перенесите файл на эту область<br/><b>или</b><br/>нажмите для открытия диалога выбора файла.</span>
				</div>
			);
		} else {
			return (
				<div className="dropzone-label">
                    <img src="/img/file_icon.png" className="dropzone-icon" alt="file" />
					<span>{this.state.file.name}</span>
				</div>
			);
		}
    }
    
    renderCarrierList() {
        return (
            <div style={{paddingBottom:10}}>
                <label htmlFor="selectCarrier" title={"Транспортная компания"}>Транспортная компания<span className="text-red">*</span></label>
                <SelectInput id="selectCarrier"
                    clearable={false}
                    options={this.state.carriersList}
                    value={this.state.carrierId}
                    onChange={e => { this.setState({carrierId: e.value}); }}
                    title={"Транспортная компания"} />
            </div>
        );
    }

    render() {
		let dragzoneClass = "dropzone has-advanced-upload" + (this.state.dragOver ? " is-dragover" : "");
        return (
            <Modal show={this.state.isOpen} 
				onHide={() => this.close(false)} 
				aria-labelledby="ModalHeader" 
				backdrop="static"
			>
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>
						{this.state.title}
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        {this.renderCarrierList()}
                        <Dropzone multiple={false}
                            onDrop={files => this.onDrop(files)}
                            styles={{}}
                            className={dragzoneClass}
                        >
						{this.renderDropzoneBody()}
					</Dropzone>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' 
						onClick={() => this.close(true)}
						disabled={this.state.file == null || this.state.carrierId == null}
					>
						Отправить
					</button>
                    <Modal.Dismiss className='btn btn-default'>
						Отмена
					</Modal.Dismiss>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/fileSelectionWithCarrierSelectionModal.jsx